import { render, staticRenderFns } from "./_slots.vue?vue&type=template&id=05208e5a&"
import script from "./_slots.vue?vue&type=script&lang=js&"
export * from "./_slots.vue?vue&type=script&lang=js&"
import style0 from "./_slots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports